import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from '@/components/HelloWorld'
import restaurant from '@/components/restaurant'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: '/',
      component: restaurant
    },
    {
      path: '/inviteUrl',
      name: 'inviteUrl',
      redirect: '/'
      // component: HelloWorld
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js